import { type MantineColorScheme } from '@mantine/core'
import Image from 'next/image'

import { ACCOUNT_LOGO_CONFIG } from './constants'
import { getAccountLogoSrc, hasAccountLogo } from './utils'

type AccountLogoProps = {
  account?: string
  colorScheme: MantineColorScheme
}

const AccountLogo = (props: AccountLogoProps) => {
  const { account, colorScheme } = props

  if (!hasAccountLogo(account)) {
    return null
  }

  const { width, height } = ACCOUNT_LOGO_CONFIG[account]
  const src = getAccountLogoSrc(account, colorScheme) ?? ''

  return <Image alt={account} height={height} src={src} title={account} width={width} />
}

export default AccountLogo
